import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { POST } from 'src/app/network/network.service';

@Injectable({ providedIn: 'root' })
export class LoginOtpService {
  constructor() {}

  @POST('v2/otp/verify')
  verifyLoginOtp(body: { user_id: number; otp_code: string; type: 'first_time_login' | string }): Observable<any> {
    // Network layer decorator will handle the request; just return undefined to satisfy TS signature
    return undefined as any;
  }

  @POST('v2/otp/resend')
  resendLoginOtp(body: { user_id: number; type: 'first_time_login' | string; channel: 'email' | string }): Observable<any> {
    return undefined as any;
  }
}


